import {useEffect, useState} from "react";
import ServerData from "../serverData";
import {SETTINGS} from "../settings";

/**
 * @param {string} [accessToken=""]
 * @return {ServerData}
 * */
export function useClient(accessToken = '') {
    const isManager = true;
    const [client, setClient] = useState(new ServerData(null, null, { accessToken, isManager }));

    if (SETTINGS.bllink.exposeClient) {
        useEffect(function() {
            window.apiClient = client;
        }, [accessToken]);
    }

    const oldAuthz = client.axios.defaults.headers.Authorization ?? 'Bearer ';
    const newAuthz = `Bearer ${accessToken ?? ''}`;

    if (oldAuthz !== newAuthz) {
        const newClient = new ServerData(null, null, { accessToken, isManager });
        setClient(newClient);
        return newClient;
    }
    return client;
}
